import React, { useState } from 'react';
import { Phone, MessageCircle, X } from 'lucide-react';
import { cn } from '../lib/utils';
export const FloatingContact = () => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="fixed bottom-6 right-6 z-50 md:hidden flex flex-col items-end gap-3" data-id="element-40">
      {/* Menu Items */}
      <div className={cn('flex flex-col gap-3 transition-all duration-300 origin-bottom', isOpen ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-90 translate-y-4 pointer-events-none')} data-id="element-41">
        <a href="tel:+380000000000" className="flex items-center gap-3 bg-white border border-gray-200 text-black px-4 py-3 rounded-full shadow-lg font-medium" data-id="element-42">
          <span className="text-sm" data-id="element-43">Зателефонувати</span>
          <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-44">
            <Phone className="w-4 h-4" data-id="element-45" />
          </div>
        </a>
        <a href="#" className="flex items-center gap-3 bg-white border border-gray-200 text-black px-4 py-3 rounded-full shadow-lg font-medium" data-id="element-46">
          <span className="text-sm" data-id="element-47">Telegram</span>
          <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-48">
            <MessageCircle className="w-4 h-4" data-id="element-49" />
          </div>
        </a>
        <a href="#" className="flex items-center gap-3 bg-white border border-gray-200 text-black px-4 py-3 rounded-full shadow-lg font-medium" data-id="element-50">
          <span className="text-sm" data-id="element-51">Viber</span>
          <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-52">
            <MessageCircle className="w-4 h-4" data-id="element-53" />
          </div>
        </a>
      </div>

      {/* Main Toggle Button */}
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center justify-center w-14 h-14 bg-black text-white rounded-full shadow-lg hover:bg-gray-800 transition-colors" data-id="element-54">
        {isOpen ? <X className="w-6 h-6" data-id="element-55" /> : <Phone className="w-6 h-6" data-id="element-56" />}
      </button>
    </div>;
};